var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHttpHttpsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_693_972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5 9V7.875C49.5 4.77 46.98 2.25 43.875 2.25C40.77 2.25 38.25 4.77 38.25 7.875V9C37.0125 9 36 10.0125 36 11.25V20.25C36 21.4875 37.0125 22.5 38.25 22.5H49.5C50.7375 22.5 51.75 21.4875 51.75 20.25V11.25C51.75 10.0125 50.7375 9 49.5 9ZM47.7 9H40.05V7.875C40.05 5.76 41.76 4.05 43.875 4.05C45.99 4.05 47.7 5.76 47.7 7.875V9ZM42.57 27C42.66 27.7425 42.75 28.485 42.75 29.25C42.75 33.93 40.95 38.1825 38.025 41.3775C37.44 39.555 35.775 38.25 33.75 38.25H31.5V31.5C31.5 30.2625 30.4875 29.25 29.25 29.25H15.75V24.75H20.25C21.4875 24.75 22.5 23.7375 22.5 22.5V18H27C29.475 18 31.5 15.975 31.5 13.5V7.785C29.3625 7.11 27.1125 6.75 24.75 6.75C12.33 6.75 2.25 16.83 2.25 29.25C2.25 41.67 12.33 51.75 24.75 51.75C37.17 51.75 47.25 41.67 47.25 29.25C47.25 28.485 47.205 27.7425 47.1375 27H42.57ZM22.5 47.0925C13.6125 45.99 6.75 38.43 6.75 29.25C6.75 27.855 6.93 26.5275 7.2225 25.2225L18 36V38.25C18 40.725 20.025 42.75 22.5 42.75V47.0925Z",
    fill: "#3BBCE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_693_972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHttpHttpsLogo);
export default __webpack_public_path__ + "static/media/http-https-logo.5f1c6ae16ae7fdd114c02ac63e9700b2.svg";
export { ForwardRef as ReactComponent };